<template>
  <va-card  class="flex mb-4">
    <va-card-title style="height: 30px;padding:5px;padding-left:20px ">共享管理</va-card-title>
    <va-card-content>
      <div>
        <div>
          <vxe-form :data="toolbar.formData">
            <vxe-form-item title="关键字" field="searchKey" :item-render="{}">
              <template #default="{ data }">
                <vxe-input v-model="data.searchKey" placeholder="请输入文件名称"></vxe-input>
              </template>
            </vxe-form-item>
            <vxe-form-item>
              <template #default>
                <vxe-button status="primary" @click="findData" @keyup.enter="findData">查询</vxe-button>
                <vxe-button @click="clear">重置</vxe-button>
                <vxe-button status="success" @click="add">新增</vxe-button>
              </template>
            </vxe-form-item>
          </vxe-form>
        </div>
        <div style="overflow: hidden;height: 100%">
          <vxe-table
            stripe
            class="mytable-scrollbar"
            ref="table"
            :data="tableData"
            :height="tableHeight"
            show-overflow
            :row-config="{height: 36,isHover: true,isCurrent:true}"
           >
            <vxe-column type="seq" field="id" title="序号" width="60"></vxe-column>
            <vxe-column title="删除" width="50" show-overflow>
              <template #default="{ row }">
                <vxe-button type="text" icon="fa fa-trash-o" @click="removeShare(row)"></vxe-button>
              </template>
            </vxe-column>
            <vxe-column title="编辑" width="50" show-overflow>
              <template #default="{ row }">
                <vxe-button type="text" icon="fa fa-edit" @click="editShare(row)"></vxe-button>
              </template>
            </vxe-column>
            <vxe-column field="fileName" title="文件名称" width="280" sortable show-overflow></vxe-column>
            <vxe-column field="seq" title="排序" width="80" sortable></vxe-column>
            <vxe-column field="remark" title="备注" width="150" show-overflow></vxe-column>
            <vxe-column field="creatorName" title="创建人" width="100"></vxe-column>
            <vxe-column field="createTime" title="创建时间" width="160"></vxe-column>
            <vxe-column field="enabledName" title="是否显示" width="100"></vxe-column>
          </vxe-table>
        </div>
        <div>
          <vxe-pager
            background
            v-model:current-page="tablePager.currentPage"
            v-model:page-size="tablePager.pageSize"
            :total="tablePager.totalResult"
            @page-change="handlePageChange"
            :layouts="['PrevJump', 'PrevPage', 'JumpNumber', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']">
          </vxe-pager>
        </div>
      </div>
      <vxe-modal title="编辑共享文件" v-model="formInput.isShow" width="800" height="350">
        <template #default>
          <div>
            <vxe-form :data="formInput.formData" :rules="formInput.formRules">
              <vxe-form-item title="文件名称" field="fileName" span="14" :item-render="{}" title-width="100px">
                <template #default="{ data }">
                  <vxe-input v-model="data.fileName" placeholder="请输入文件名称" clearable></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="排序" field="seq" span="5" :item-render="{}">
                <template #default="{ data }">
                  <vxe-input v-model="data.seq" placeholder="请输入排序" clearable type="number"></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="是否显示" field="enabled" span="5" :item-render="{}">
                <template #default="{ data }">
                  <vxe-select v-model="data.enabled" clearable>
                    <vxe-option value="0" label="否"></vxe-option>
                    <vxe-option value="1" label="是"></vxe-option>
                  </vxe-select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="文件" field="fileUrl" span="14" :item-render="{}" title-width="100px">
                <template #default="{data}">
                  <vxe-input v-model="data.fileUrl" placeholder="请选择文件" readonly></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="" span="2" :item-render="{}">
                <template #default="">
                  <vxe-button @click="insertEvent">浏览</vxe-button>
                </template>
              </vxe-form-item>
              <vxe-form-item title="" span="6" :item-render="{}">
                <a v-if="isShowLink" href="javascript:void(0);" @click="downloadFile">下载</a>
              </vxe-form-item>
              <vxe-form-item title="备注" field="remark" span="24" title-width="100px">
                <vxe-textarea v-model="formInput.formData.remark" placeholder="请输入备注" maxlength="500"
                  show-word-count></vxe-textarea>
              </vxe-form-item>
            </vxe-form>
          </div>
          <div style="width: 780px;text-align:right;height: 50px; position: absolute;bottom: 2px; padding-right: 20px">
            <vxe-button status="primary" @click="uploadFile">保存</vxe-button>
          </div>
        </template>
      </vxe-modal>
    </va-card-content>
  </va-card>
</template>

<script>

import Qs from 'qs'
import {reactive, defineComponent, ref} from 'vue';
import {VXETable, VxeTableInstance, VxeToolbarInstance} from 'vxe-table'


export default {
  name: "ShareList",
  components: {},
  data() {
    const pageHeight = window.innerHeight-(65+48+198)+'px';//屏幕高度减去导航栏和内补白
    const tablePager = reactive({
      currentPage: 1,
      pageSize: 10,
      totalResult: 0
    })
    const toolbar = reactive({
      loading: false,
      formData: {
        searchKey: ''
      }
    })


    const formInput = reactive({
      isShow: false,
      editType: '1',
      formData: {
        id: '',
        fileName: '',
        fileUrl: '',
        enabled: '1',
        creator: '',
        modifier: '',
        remark: '',
        fileType: '1', //文件共享
        seq: ''

      }, formRules: {
        fileName: [
          {required: true, message: '文件名称不能为空'},
        ],
        seq: [
          {required: true, message: '排序不能为空'}
        ],
        fileUrl: [
          {require: true, message: '附件不能为空'}]
      }
    })

    return {
      tableData: null,
      tablePager,
      toolbar,
      formInput,
      advancedList: [],
      oneFile: {},//上传的附件
      isShowLink: false,
      pageHeight,
      tableHeight: 0
    }
  },
  methods: {
    add() {
      this.formInput.isShow = true;
      this.formInput.editType = '1';
      this.formInput.formData = {
        id: '',
        fileName: '',
        enabled: '1',
        fileUrl: '',
        creator: this.getUserId,
        modifier: this.getUserId,
        remark: '',
        fileType: '1',
        seq: ''
      };
      this.oneFile = null;
      this.isShowLink = false;
    },
    editShare(row) {
      const params = {
        'uid': this.getUserId,
        'email': this.getUserEmail,
        'currentPage': 1,
        'pageSize': 20,
        'searchKey': [row.id]
      };
      this.formInput.isShow = true;
      this.oneFile = null;

      this.$api.systemManageAPI.getShareOne(Qs.stringify(params))
        .then(res => {
          if (res.data.Success == false) {
            VXETable.modal.message({content: res.data.Message, status: 'error'});
            return;
          }
          this.formInput.isShow = true;
          this.formInput.formData = res.data.Data[0];
          this.isShowLink = true;
          this.formInput.editType = '2';//更新
        })
        .catch(error => {
          console.log(error);

        })
    },
    async removeShare(row) {
      const type = await VXETable.modal.confirm('您确定要删除该数据?')
      const $grid = this.$refs.table;

      if (type === 'confirm') {

        this.$api.systemManageAPI.deleteShare(Qs.stringify({"shareId": row.id}))
          .then(res => {
            if (res.data.Success === false) {
              VXETable.modal.message({content: res.data.Message, status: 'error'});
              return;
            }
            VXETable.modal.message({content: "删除成功", status: 'success'});
            $grid.remove(row);
          })
          .catch(error => {
            console.log(error);
          })
      }

    },
    save() {

      if (this.formInput.formData.title === '') {
        VXETable.modal.message({content: '标题不能为空', status: 'warning'});
        return;
      }
      if (this.formInput.formData.active === '') {
        VXETable.modal.message({content: '请选择是否启用', status: 'warning'});
        return;
      }
      if (this.formInput.formData.contents === '') {
        VXETable.modal.message({content: '内容不能为空', status: 'warning'});
        return;
      }

      const params = this.formInput.formData;

      //新增
      if (this.formInput.editType === '1') {
        this.$api.systemManageAPI.addShare(Qs.stringify(params))
          .then(res => {
            if (res.data.Success == false) {
              VXETable.modal.message({content: res.data.Message, status: 'error'});
              return;
            }
            VXETable.modal.message({content: '保存成功', status: 'success'});
            this.formInput.isShow = false;
            this.findData();
          })
          .catch(error => {
            VXETable.modal.alert({content: error, status: 'error'});
            console.log(error);
          });
      } else if (this.formInput.editType === '2') { //更新
        this.$api.systemManageAPI.updateShare(Qs.stringify(params))
          .then(res => {
            if (res.data.Success == false) {
              VXETable.modal.message({content: res.data.Message, status: 'error'});
              return;
            }
            VXETable.modal.message({content: '保存成功', status: 'success'});
            this.formInput.isShow = false;
            this.findData();
          })
          .catch(error => {
            VXETable.modal.message({content: error, status: 'error'});
            console.log(error);
          });
      }
    },
    launchToast(toastMsg) {
      this.$vaToast.init({
        message: toastMsg,
        iconClass: this.toastIcon,
        position: this.toastPosition,
        duration: Number(this.toastDuration),
        fullWidth: this.isToastFullWidth,
      })
    },
    calTableHeight(rowsLength) {
      let minHeight = window.innerHeight - (65 + 28 + 198);
      let calHeight = rowsLength == null ? 0 : (rowsLength + 1) * 36+22;
      this.tableHeight = Math.max(minHeight, calHeight);
    },
    findData() {
      const params = {
        'uid': this.$store.state.userID,
        'email': this.$store.state.email,
        'currentPage': this.tablePager.currentPage,
        'pageSize': this.tablePager.pageSize,
        'searchKey': [this.toolbar.formData.searchKey]
      };
      this.$api.systemManageAPI.getShareList(Qs.stringify(params))
        .then(res => {
          if (res.data.Success == false) {
            VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
            return;
          }
          // console.log(res.data.Data);
          this.tableData = res.data.Data.dataTable;
          this.tablePager.currentPage = res.data.Data.currentPage;
          this.tablePager.pageSize = res.data.Data.pageSize;
          this.tablePager.totalResult = res.data.Data.totalResult;
          this.tableHeight = this.$calTableHeight(res.data.Data.dataTable.length);

        })
        .catch(error => {
          console.log(error);

        })
    },
    handlePageChange() {
      this.findData();
    },
    clear() {
      this.toolbar.formData.searchKey = ''
    },
    keydown(e) {
      if (e.keyCode === 13) {
        this.findData();
      }
    },
    async insertEvent() {
      const {files} = await VXETable.readFile(false)
      Array.from(files).map(file => {
        this.formInput.formData.fileUrl = file.name;
        this.oneFile = file;
      })
    },
    //保存
    uploadFile() {
      if (this.formInput.formData.fileName === '') {
        VXETable.modal.message({content: '文件名称为空', status: 'warning'});
        return;
      }
      if (this.formInput.formData.seq === '') {
        VXETable.modal.message({content: '请输入排序', status: 'warning'});
        return;
      }
      if (this.formInput.formData.enabled === '') {
        VXETable.modal.message({content: '请选择是否显示', status: 'warning'});
        return;
      }
      if (this.formInput.formData.fileUrl === '') {
        VXETable.modal.message({content: '请选择附件', status: 'warning'});
        return;
      }

      if (this.formInput.formData.fileUrl === '' && (this.oneFile === null || this.oneFile == '')) {
        VXETable.modal.message({content: '请选择附件', status: 'warning'});
        return;
      }
      debugger
      const data = new FormData();
      data.append('file',this.oneFile );
      data.append('id', encodeURIComponent(this.formInput.formData.id));
      data.append('fileName', encodeURIComponent(this.formInput.formData.fileName));
      data.append('enabled', encodeURIComponent(this.formInput.formData.enabled));
      data.append('fileUrl', encodeURIComponent(this.formInput.formData.fileUrl));
      data.append('creator', encodeURIComponent(this.formInput.formData.creator));
      data.append('modifier', encodeURIComponent(this.formInput.formData.modifier));
      data.append('remark', encodeURIComponent(this.formInput.formData.remark));
      data.append('fileType', encodeURIComponent(this.formInput.formData.fileType));
      data.append('seq', encodeURIComponent(this.formInput.formData.seq));

      //新增
      if (this.formInput.editType === '1') {
        this.$api.systemManageAPI.addShare(data)
          .then(res2 => {
            if (res2.data.Success == false) {
              VXETable.modal.message({content: res2.data.Message, status: 'error'});
              return;
            }
            VXETable.modal.message({content: '保存成功', status: 'success'});
            this.formInput.isShow = false;
            this.findData();
          })
          .catch(error2 => {
            VXETable.modal.alert({content: error2, status: 'error'});
            console.log(error2);
          });
      } else { //修改
        this.$api.systemManageAPI.updateShare(data)
          .then(res2 => {
            if (res2.data.Success == false) {
              VXETable.modal.message({content: res2.data.Message, status: 'error'});
              return;
            }
            VXETable.modal.message({content: '保存成功', status: 'success'});
            this.formInput.isShow = false;
            this.findData();
          })
          .catch(error2 => {
            VXETable.modal.alert({content: error2, status: 'error'});
            console.log(error2);
          });
      }


    },
    downloadFile() {

      this.$api.fileManageAPI.downloadShareFile(Qs.stringify({"shareId": this.formInput.formData.id}))
        .then(res => {
          if (res.data.Success === false) {
            VXETable.modal.message({content: res.data.Message, status: 'error'});
            return;
          }

          window.open(res.data.Data, "_blank").location;
          // const downloadLink = document.createElement('a')
          // downloadLink.download = this.formInput.formData.fileUrl;
          // downloadLink.style.display = 'none'
          // downloadLink.href = res.data.Data;
          // document.body.appendChild(downloadLink)
          // downloadLink.click()
          // document.body.removeChild(downloadLink)
        })
        .catch(error => {
          console.log(error);
        })

    }
  },
  mounted() {
    this.findData();
    this.formInput.formData.creator = this.getUserId;
    this.formInput.formData.modifier = this.getUserId;
    window.addEventListener("keydown", this.keydown)
  },
  unmounted() {
    window.removeEventListener("keydown", this.keydown, false);
  },
  computed: {
    getUserName() {
      return this.$store.state.userName;
    },
    getJobZb() {
      return this.$store.state.jobZb;
    },
    getJobName() {
      return this.$store.state.jobName;
    },
    getUserEmail() {
      return this.$store.state.email;
    },
    getUserId() {
      return this.$store.state.userID;
    }
  }
}

</script>


<style type="text/css">
td.vxe-body--column {
  vertical-align: middle;
}
</style>
